module.exports = {
    events: {
        click: {
            selector: 'label',
            type: 'click',
            action: function(event){
                const $target = $(event.target).closest('label')
                if($target.length > 0){
                    event.data.component.find('base_form_fields_toggle', toggle => {
                        toggle.toggle()
                    })
                }
            }
        }
    },

    hooks: {
        onChildChanged($element, options){
            this.parent(parentComponent => {
                parentComponent.trigger('onChildChanged', options);
            })
        }
    }
}